export const MobileData = [
  {
    title: 'Container Ship Arrives at the port terminal',
    img: '/static/images/pages/smart-port/card-1.png'
  },
  {
    title: 'Aerial Drone deploys and takes aerial footage',
    img: '/static/images/pages/smart-port/card-2.png',
    subtitle: 'Scale’s AI counts containers, tracks location, identifies damage'
  },
  {
    title: 'Each Crane’s Container ID is stored in Scale’s Digital Receipt Registry',
    img: '/static/images/pages/smart-port/card-3.png',
    subtitle: 'Imagery stored as part<br/>of Digital Receipt registry'
  },
  {
    title: 'Autonomous crane collects containers from the ship and loads onto bombcart',
    img: '/static/images/pages/smart-port/card-4.png'
  },
  {
    title: 'Drones and other sensors document the journey of the container to storage location',
    img: '/static/images/pages/smart-port/card-5.png'
  },
  {
    title: 'Perimeter Security',
    img: '/static/images/pages/smart-port/card-6.png'
  },
  {
    title: 'Containers stacked efficiently with AI-Assisted logic',
    img: '/static/images/pages/smart-port/card-7.png'
  }
];
